export default __webpack_public_path__ + "static/B0202-14a42e44ae36d89e5332ad0a2b7fc991.png";